// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sCTqc2pcEy7Gl0vff3uS {
  max-height: 100px;
}

.fKe2QhzykfXIaGp4QLoa {
  margin: 2px 4px 2px 0 !important;
}`, "",{"version":3,"sources":["webpack://./js/view/component/table-columns/status-tags/styles.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;;AAEA;EACE,gCAAA;AACF","sourcesContent":[".tag_wrapper {\n  max-height: 100px;\n}\n\n.tag {\n  margin: 2px 4px 2px 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tag_wrapper": `sCTqc2pcEy7Gl0vff3uS`,
	"tag": `fKe2QhzykfXIaGp4QLoa`
};
export default ___CSS_LOADER_EXPORT___;
